import React from 'react';
import { Edit, SimpleForm, TabbedShowLayout, Tab, ReferenceManyField, Pagination } from 'react-admin';

import { SaveWithCancelToolbar } from '../../../components/toolbars/SaveWithCancelToolbar';
import { TerminalsEditForm } from './EditForm';
import { DocumentTemplateList } from 'components/DocumentTemplates';
import Card from '@material-ui/core/Card';

export const TerminalsEdit = (props) => {

    return (		
        <TabbedShowLayout style={{paddingBottom: 8}} basePath={props.basePath}>
            <Tab label="tab.geneneral.name" >
                <Edit {...props} undoable={false}>
                    <SimpleForm submitOnEnter={false} toolbar={<SaveWithCancelToolbar />}>
                        <TerminalsEditForm />
                    </SimpleForm>
                </Edit>
            </Tab>
            <Tab label="tab.document-template-default.name" path="document-templates">
                <Card>
                    <ReferenceManyField label={false} fullWidth reference="document-templates" filter={{"terminal_id": props.id}}
                                        pagination={<Pagination rowsPerPageOptions={[5, 10, 15, 20, 25]} />} perPage={5} >
                        <DocumentTemplateList isDefaultDocTemplate={true} {...props}/>
                    </ReferenceManyField>
                </Card>
            </Tab>
        </TabbedShowLayout>
    );
};

